import React from 'react'
import InsurerSystemsDirectory from '../components/InsurerSystemsDirectory'

export default function InsurerSystemsPage() {
  return <InsurerSystemsDirectory variant="standalone" />
}
